import React, { useState } from 'react'
import './SpringbootSettings.css'
import { Back } from '../../../../../../../../../components/back/Back'

function SpringbootSettings({ back, next, intialData, serviceName }) {

    const [data, setData] = useState(Object.keys(intialData).length > 1 ? intialData : {
            "type": "maven-project",
            "language": "java",
            "bootVersion": "4.0.1",
            "groupId": "com.example",
            "artifactId": serviceName,
            "name": serviceName,
            "description": "Demo project for Spring Boot",
            "packageName": `com.example.${serviceName}`,
            "packaging": "jar",
            "javaVersion": "25",
            "configurationFileFormat": "properties",
            "dependencies": "",
    })

  return (
    <div className='springboot-setting'>
        <Back back={()=>{back(data)}}/>
        {/* <h1>Spring Boot Settings</h1> */}
        
        <div className='section'>
            <div className='name'>
                <label>Name</label>
                <input value={data.name} onChange={(e)=>setData({...data, artifactId: e.target.value, name: e.target.value, packageName: `${data.groupId}.${e.target.value}`})}></input>
            </div>
            </div>
        <div className='section main-section'>
            <div className='info-block'>
                <label>Project</label>
                <select>
                    <option value="maven-project">Maven</option>
                    <option value="gradle-project">Gradle</option>
                </select>
            </div>
            <div className='info-block'>
                <label>Language</label>
                <select onChange={(e)=>{setData({...data, language: e.target.value})}}>
                    <option selected={data.language === "java"} value="java">Java</option>
                    <option selected={data.language === "kotlin"} value="kotlin">Kotlin</option>
                    <option selected={data.language === "groovy"} value="groovy">Groovy</option>
                </select>
            </div>
            <div className='info-block'>
                <label>Spring Boot</label>
                <select onChange={(e)=>setData({...data, bootVersion: e.target.value})}>
                    <option selected={data.bootVersion === "4.0.2-SNAPSHOT"} value="4.0.2-SNAPSHOT">4.0.2 (SNAPSHOT)</option>
                    <option selected={data.bootVersion === "4.0.1"} value="4.0.1">4.0.1</option>
                    <option selected={data.bootVersion === "3.5.9"} value="3.5.9">3.5.9</option>
                    <option selected={data.bootVersion === "3.5.10-SNAPSHOT"} value="3.5.10-SNAPSHOT">3.5.10 (SNAPSHOT)</option>
                </select>
            </div>

            <div className='info-block'>
                <label>Group</label>
                <input value={data.groupId} onChange={(e)=>setData({...data, groupId: e.target.value, packageName: `${e.target.value}.${data.artifactId}`})}></input>
            </div>
            <div className='info-block'>
                <label>Artifect</label>
                <input value={data.artifactId} onChange={(e)=>setData({...data, artifactId: e.target.value})}></input>
            </div>
            <div className='info-block'>
                <label>Description</label>
                <input className='description' value={data.description} onChange={(e)=>setData({...data, description: e.target.value})}></input>
            </div>
            <div className='info-block'>
                <label>Package name</label>
                <input className='package-name' value={data.packageName} onChange={(e)=>setData({...data, packageName: e.target.value})}></input>
            </div>

            <div className='info-block'>
                <label>Packaging</label>
                <select onChange={(e)=>setData({...data, packaging: e.target.value})}>
                    <option selected={data.packaging === "jar"} value="jar">Jar</option>
                    <option selected={data.packaging === "war"}  value="war">War</option>
                </select>
            </div>
            <div className='info-block'>
                <label>Configuration</label>
                <select onChange={(e)=>setData({...data, configurationFileFormat: e.target.value})}>
                    <option selected={data.configurationFileFormat === "properties"} value="properties">Properties</option>
                    <option selected={data.configurationFileFormat === "yaml"} value="yaml">YAML</option>
                </select>
            </div>
            <div className='info-block'>
                <label onChange={(e)=>setData({...data, javaVersion: e.target.value})}>Java</label>
                <select>
                    <option selected={data.javaVersion === "25"} value="25">25</option>
                    <option selected={data.javaVersion === "21"} value="21">21</option>
                    <option selected={data.javaVersion === "17"} value="17">17</option>
                </select>
            </div>
        </div>
        <button className='next-button' onClick={(e)=>{e.preventDefault();next(data)}}>next</button>
    </div>
  )
}

export default SpringbootSettings